import Vue from 'vue'
import Router from 'vue-router'
import dashboards from './dashboards.route'
import users from './users.route'
import purchases from './purchases.route'
import services from './services.route'
import feedbacks from './feedbacks.route'
import experts from './experts.route'
import session from './session.route'
import transfers from './transfers.route'
import customizations from './customizations.route'
import messenger from './messenger.route'
import errors from './errors.route'

Vue.use(Router)

const scrollBehavior = (to, from, savedPosition) => {
  if (to.hash) { return { selector: to.hash } }
  if (savedPosition) { return savedPosition }
  return { x: 0, y: 0 }
}

export default new Router({
  mode: 'history',
  scrollBehavior,
  routes: [
    ...dashboards,
    ...session,
    ...users,
    ...purchases,
    ...services,
    ...feedbacks,
    ...transfers,
    ...customizations,
    ...experts,
    ...messenger,
    ...errors
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js